import { Chart } from './components'

export {
  Chart as VFrappeChart
}

export default {
  install (Vue) {
    Vue.component('v-frappe-chart', Chart)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-frappe-chart/src/index.js
// module id = 1151
// module chunks = 1